import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes, PageClientSideFilters } from "@ryde/layout";

export const AdditionsPage: FC = () => {
  return (
    <PageContextWrapper entity="addition">
      <PageClientSideFilters />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
